import script from "./EducatorData.vue?vue&type=script&setup=true&lang=js"
export * from "./EducatorData.vue?vue&type=script&setup=true&lang=js"

import "./EducatorData.vue?vue&type=style&index=0&id=1aa988ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aa988ca"]])

export default __exports__